export function parseDateToUTC(date, isMaxDateTime = false) {
	let utcDateTime = new Date(date);
	if (isMaxDateTime) {
		// Add a day
		utcDateTime.setDate(utcDateTime.getDate() + 1);
		// Subtract a second
		utcDateTime.setSeconds(utcDateTime.getSeconds() - 1);
	}
	// Display UTC time
	return utcDateTime.toUTCString();
}
